module.exports = "<div><br><div class=\"filter-cut\" ng-repeat=\"cut in $ctrl.filter.filters\">{{$ctrl.cutDimension(cut)}}:<b>{{$ctrl.cutValue(cut)}}</b></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/filter-stamp/filter-stamp.component.html
// module id = 970
// module chunks = 0